import {defineMessages} from 'react-intl';

export default defineMessages({
  generalError: {
    defaultMessage: 'Please check and fix all form errors',
    id: 'ReactiveForms.FormsSystem.GeneralError',
  },
});
